import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import CreateSweepRuleForSenderJsonRequest from 'owa-service/lib/contract/CreateSweepRuleForSenderJsonRequest';
import CreateSweepRuleForSenderResponseMessage from 'owa-service/lib/contract/CreateSweepRuleForSenderResponseMessage';
import CreateSweepRuleForSenderRequest from 'owa-service/lib/contract/CreateSweepRuleForSenderRequest';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import createSweepRuleForSenderRequest from 'owa-service/lib/factory/createSweepRuleForSenderRequest';
import createSweepRuleForSenderOperation from 'owa-service/lib/operation/createSweepRuleForSenderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses: EmailAddressWrapper[]) {
    return emailAddresses.map(email => {
        return '';
    });
}

/**
 * Apply bulk item action service
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
export default function blockSenderService(
    emailAddresses: EmailAddressWrapper[]
): Promise<CreateSweepRuleForSenderResponseMessage> {
    const requestBody = createSweepRuleForSenderRequest(<CreateSweepRuleForSenderRequest>{
        EmailAddresses: emailAddresses,
        ActionType: BulkTriageActionType.Block,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
    });

    return createSweepRuleForSenderOperation(<CreateSweepRuleForSenderJsonRequest>{
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0] as CreateSweepRuleForSenderResponseMessage;
    });
}
